import { api, registry } from './api';
import CacheStorage from './CacheStorage';

const baseURL = `${process.env.REACT_APP_API_URL}api`;

/* const cacheStorage = new CacheStorage();

 const getCachedDivisions = async () => {
  const url = `${baseURL}/me/divisions`;
  const items = await cacheStorage.getFromCache(url);
  return items || undefined;
};
const getCachedWorkSites = async () => {
  const url = `${baseURL}/me/worksites`;
  const items = await cacheStorage.getFromCache(url);
  return items || undefined;
};
const getCachedCompanies = async () => {
  const url = `${baseURL}/company`;
  const items = await cacheStorage.getFromCache(url);
  return items || undefined;
};

const getCachedProjects = async () => {
  const url = `${baseURL}/project`;
  const items = await cacheStorage.getFromCache(url);
  return items || undefined;
}; */

const MeRepository = {
  getDivisions: async () =>
    /* (await getCachedDivisions()) ||  */ (await api.getAll(`${baseURL}/me/divisions`)).data,
  getAllDivisions: async () =>
    /* (await getCachedDivisions()) ||  */ (await api.getAll(`${baseURL}/division`)).data,
  getCompanies: async () =>
    /* (await getCachedCompanies()) || */ (await api.getAll(`${baseURL}/company`)).data,
  getProjects: async (company) => {
    const projects = /* (await getCachedProjects()) || */ (await api.getAll(`${baseURL}/project`))
      .data;
    if (company) return projects.filter((w) => w.idCompany === company);
    return projects;
  },
  getWorkSites: async () =>
    /*  (await getCachedWorkSites()) || */ (await api.getAll(`${baseURL}/me/worksites`)).data,
  preFetch: async () => {
    await api.getAll('/me/divisions');
    await api.getAll('/company');
    await api.getAll('/project');
    await api.getAll('/me/project');
    await api.getAll('/me/companies');
    await registry.getAll('infooriginator');
    await registry.getAll('status');
    await api.getAll('/country');
    await api.getAll('/me/worksites');
    await api.getAll('/me/worksitesproject');
    await api.getAll('/employees/all');
    await api.getAll(`${baseURL}/division`);
    //await api.getAll("/users/userworksite");
  },
};
export default MeRepository;
